<script setup lang="ts">
import { Switch, SwitchGroup, SwitchLabel } from '@headlessui/vue'

const modelValue = defineModel<boolean>({ default: false })

const props = defineProps({
    disabled: { type: Boolean, default: false },
    color: { type: String, default: 'lime' },
})

const colorClasses: Record<string, { bg: string; ring: string; text: string }> = {
    lime: { bg: 'bg-lime-500', ring: 'focus:ring-lime-400', text: 'text-lime-500' },
    orange: { bg: 'bg-orange-500', ring: 'focus:ring-orange-400', text: 'text-orange-500' },
    red: { bg: 'bg-red-500', ring: 'focus:ring-red-400', text: 'text-red-500' },
    blue: { bg: 'bg-blue-500', ring: 'focus:ring-blue-400', text: 'text-blue-500' },
    gray: { bg: 'bg-gray-500', ring: 'focus:ring-gray-400', text: 'text-gray-500' },
}

const current = colorClasses[props.color] || colorClasses.lime
</script>

<template>
    <SwitchGroup as="div" class="flex items-center gap-1">
        <!-- Label -->
        <SwitchLabel as="span" :class="['font-medium select-none transition-colors duration-200', modelValue ? current.text : 'text-gray-400']">
            <slot name="label"> </slot>
        </SwitchLabel>

        <!-- Switch -->
        <Switch v-model="modelValue" :disabled="props.disabled" :class="[
            'relative inline-flex h-6 w-11 items-center rounded-full transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-1',
            props.disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer',
            modelValue ? `${current.bg} ${current.ring}` : 'bg-gray-300'
        ]">
            <span aria-hidden="true" class="inline-block h-4 w-4 transform rounded-full bg-white transition-transform duration-200" :class="modelValue ? 'translate-x-6' : 'translate-x-1'" />
        </Switch>
    </SwitchGroup>
</template>